/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `SETUP` - Setup
 * * `MISSING_INFO` - Missing Info
 * * `COMPLETE` - Complete
 * * `REJECTED` - Rejected
 */
export enum RegistrationStatusEnum {
    SETUP = 'SETUP',
    MISSING_INFO = 'MISSING_INFO',
    COMPLETE = 'COMPLETE',
    REJECTED = 'REJECTED',
}
